import "./prizepoll.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./datatablesource";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";




const Datatable = () => {
  const [data, setData] = useState([]);
  const location = useLocation();
  const contestId = new URLSearchParams(location.search).get("contestid"); // Get contestid from URL

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const contestId = params.get("uid");

  }, [location.search]);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "prizepoll"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          const docData = { id: doc.id, ...doc.data() };
          // Filter based on contestid if present
          if (!contestId || docData.contest_id === contestId) {
            list.push(docData);
          }
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, [contestId]); // Re-fetch data if contestId changes

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "prizepoll", id)); // Corrected the collection name in deleteDoc
      setData(data.filter((item) => item.id !== id));
    } catch (err) {
      console.log(err);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/prizepoll/fullview?uid=${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
        <div className="datatableTitle">
        Prize Poll
        <Link to={`/prizepoll/new?uid=${contestId}`} className="link">
          Add Gift
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
